import {
  Button,
  Card,
  Collapse,
  ControlGroup,
  EditableText,
  Elevation,
  H3,
  Tag,
} from "@blueprintjs/core";
import React from "react";
import { inject, observer } from "mobx-react";
import IMSInfoDelete from "../utils/IMSInfoDelete";
import EntityComments from "./EntityComments";
import _ from "lodash";
import EntityFiles from "./EntityFiles";
import ArrayStringContentMaster from "./ArrayStringContentMaster";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./MasterEntity.css";
class MasterEntity extends React.Component {
  state = {
    isUpdating: false,
    changedName: false,
    changed: false,
    entityName: "",
    isCashless: false,
    changedCashType: false,
    updatedPropObject: null,
    isOpen: false,
    text: "",
    changedText: false,
  };

  renderSave = () => {
    if (this.props.entityType === "sxDischargeTemplateMaster") {
      return (
        <ControlGroup style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            loading={this.props.isBusy}
            disabled={this.props.isBusy}
            // fill
            intent="success"
            text="Save Changes"
            icon="endorsed"
            onClick={() => {
              let payload = this.state.updatedPropObject || this.props.data;
              payload["entityName"] = this.state.changedName
                ? this.state.entityName
                : this.props.data.entityName;
              payload["isCashless"] = this.state.isCashless;
              payload["content"] = this.state.changed
                ? this.state.text
                : this.props.data.content;
              this.setState({ isUpdating: true }, () => {
                this.props.onUpdate(payload);
              });
            }}
          />
        </ControlGroup>
      );
    }

    if (!this.state.changed) {
      return null;
    }
    if (this.props.entityType === "item") {
      if (!this.props.data.isCurrent) {
        return (
          <ControlGroup>
            <Tag large>This is an obsolete item and cannot be edited</Tag>
          </ControlGroup>
        );
      }
    }

    return (
      <ControlGroup>
        <Button
          loading={this.props.isBusy}
          disabled={this.props.isBusy}
          fill
          intent="success"
          text="Save Changes"
          icon="endorsed"
          onClick={() => {
            let payload = this.state.updatedPropObject || this.props.data;
            payload["entityName"] = this.state.changedName
              ? this.state.entityName
              : this.props.data.entityName;
            payload["isCashless"] = this.state.isCashless;
            payload["content"] = this.state.text;
            this.setState({ isUpdating: true }, () => {
              this.props.onUpdate(payload);
            });
          }}
        />
        <Button
          disabled={this.props.isBusy}
          icon="delete"
          text="Cancel"
          onClick={() => this.setState({ changed: false })}
        />
      </ControlGroup>
    );
  };
  renderEntity = () => {
    if (
      [
        "sxCounsellingPrompt",
        "sxTPAMaster",
        "sxPaymentPanelMaster",
        "sxConsentList",
        "sxOTMaster",
      ].includes(this.props.entityType)
    ) {
      return (
        <ArrayStringContentMaster
          isCashless={
            this.state.changedCashType
              ? this.state.isCashless
              : this.props.data.isCashless
          }
          sites={this.props.sites}
          entityType={this.props.entityType}
          displayTitle={this.props.displayTitle}
          key={`${this.props.data._id}__{this.props.data.updatedAt}`}
          indexContentName={this.props.indexContentName}
          data={this.props.data}
          onUpdate={(updatedPropObject) =>
            this.setState({
              updatedPropObject: updatedPropObject,
              changed: true,
            })
          }
        />
      );
    }
  };
  normalizeQuillContent = (content) => {
    console.log("Before normalization:", content);
    // Remove extra line breaks at the start and end
    content = content.replace(/^(<p><br><\/p>)+|(<p><br><\/p>)+$/g, "");
    // Replace multiple consecutive <br> tags with a single one
    content = content.replace(/(<br\s*\/?>){2,}/gi, "<br>");
    // Remove empty paragraphs
    content = content.replace(/<p>\s*<\/p>/g, "");
    console.log("After normalization:", content);
    return content.trim();
  };
  handleChange(value) {
    const normalizedValue = this.normalizeQuillContent(value);
    this.setState({ text: normalizedValue, changedText: true });
  }

  renderEverything = () => {
    return (
      <>
        {" "}
        {this.renderEntity()}
        <br />
        {this.props.entityType === "sxDischargeTemplateMaster" ? (
          <ReactQuill
            preserveWhitespace={true}
            style={{ height: "150px", marginBottom: "50px" }}
            theme="snow"
            value={
              this.state.changedText ? this.state.text : this.props.data.content
            }
            onChange={(val) => this.handleChange(val)}
            modules={{
              // clipboard: {
              //   matchVisual: false,
              // },
              toolbar: [
                [{ header: [1, 2, false] }],
                ["bold", "italic", "underline", "strike", "blockquote"],
                [
                  { list: "ordered" },
                  { list: "bullet" },
                  { indent: "-1" },
                  { indent: "+1" },
                ],
                ["link", "image"],
                ["clean"],
              ],
            }}
            formats={[
              "header",
              "bold",
              "italic",
              "underline",
              "strike",
              "blockquote",
              "list",
              "bullet",
              "indent",
              "link",
              "image",
            ]}
          />
        ) : null}
        {this.renderSave()}
        {this.props.entityType === "sxDischargeTemplateMaster" ? (
          <div style={{ height: "50px" }}></div>
        ) : (
          <>
            <EntityComments data={this.props.data} />
            <EntityFiles data={this.props.data} />
          </>
        )}
      </>
    );
  };
  renderLifecycleTag = () => {
    if (["materialRequests", "purchaseOrder"].includes(this.props.entityType)) {
      let intent = "";
      let icon = "";
      if (this.props.data.state === "DRAFT") {
        intent = "primary";
        icon = "wind";
      }
      if (this.props.data.state === "SUBMITTED") {
        intent = "warning";
        icon = "confirm";
      }
      if (this.props.data.state === "FULFILLED") {
        intent = "success";
        icon = "endorsed";
      }
      if (this.props.data.state === "CANCELLED") {
        intent = "danger";
        icon = "error";
      }
      return (
        <ControlGroup>
          {" "}
          <Tag icon={icon} intent={intent}>
            {_.startCase(_.toLower(this.props.data.location))}
          </Tag>
          <Tag icon="multi-select" minimal>
            {this.props.data.items.length}
          </Tag>
          {this.props.data.involvesSurgery ? (
            <Tag icon="diagnosis" intent="success"></Tag>
          ) : null}
          {this.props.data.urgentFlag ? (
            <Tag icon="flash" intent="danger"></Tag>
          ) : null}
        </ControlGroup>
      );
    } else return null;
  };
  renderTitle = () => {
    if (this.props.entityType === "ledger") {
      let icon = "";
      let intent = "";
      if (this.props.data.action === "SHIPMENT") {
        icon = "truck";
        intent = "warning";
      }
      if (this.props.data.action === "ADD") {
        icon = "cube-add";
        intent = "success";
      }
      if (this.props.data.action === "REMOVE") {
        icon = "graph-remove";
        intent = "danger";
      }
      if (this.props.data.action === "USE") {
        icon = "projects";
        intent = "primary";
      }
      if (this.props.data.action === "RETURN") {
        icon = "reset";
        intent = "danger";
      }
      return (
        <ControlGroup>
          {" "}
          <Tag large intent={intent} icon={icon}>
            {_.startCase(_.lowerCase(this.props.data.action))}
          </Tag>
          <Tag minimal large>
            {this.props.data.recvLocation.branchStoreName} -{" "}
            {this.props.data.recvLocation.branchName}
          </Tag>
          {this.props.data.action === "SHIPMENT" ? (
            <>
              <Tag minimal large icon="arrow-right"></Tag>
              <Tag minimal large>
                {
                  this.props.data.actionMetadata.toReceivingLocation
                    .branchStoreName
                }{" "}
                -{" "}
                {this.props.data.actionMetadata.toReceivingLocation.branchName}
              </Tag>
            </>
          ) : null}
        </ControlGroup>
      );
    } else {
      return (
        <>
          {" "}
          <H3>
            {this.props.entityType === "item" &&
            this.props.data.itemNameSuffix ? (
              <>
                {this.props.data.entityName} - {this.props.data.itemNameSuffix}
              </>
            ) : (
              <>
                <EditableText
                  disabled={this.props.isBusy}
                  value={
                    this.state.changedName
                      ? this.state.entityName
                      : this.props.data.entityName
                  }
                  onChange={(text) =>
                    this.setState({
                      changedName: true,
                      changed: true,
                      entityName: text,
                    })
                  }
                />

                {this.props.entityType ===
                "sxDischargeTemplateMaster" ? null : (
                  <Tag
                    style={{ marginLeft: "20px" }}
                    large
                    interactive
                    onClick={() => {
                      this.setState({
                        isCashless: this.state.changedCashType
                          ? !this.state.isCashless
                          : !this.props.data.isCashless,

                        changedCashType: true,
                        changed: true,
                      });
                    }}
                    intent={
                      this.state.changedCashType
                        ? this.state.isCashless
                          ? "success"
                          : ""
                        : this.props.data.isCashless
                        ? "success"
                        : ""
                    }
                  >
                    {this.state.changedCashType
                      ? this.state.isCashless
                        ? "Cashless"
                        : "Cash"
                      : this.props.data.isCashless
                      ? "Cashless"
                      : "Cash"}
                  </Tag>
                )}
              </>
            )}
          </H3>
        </>
      );
    }
  };
  render() {
    return (
      <div className="card__top__bottom__space">
        <Card
          elevation={Elevation.TWO}
          className={this.state.changed ? "unsaved__bg" : ""}
        >
          <div className="push__apart">
            <>{this.renderTitle()} </>

            <ControlGroup>
              {this.props.keepCollapsed ? (
                <Button
                  icon={
                    this.state.isOpen
                      ? "double-chevron-up"
                      : "double-chevron-down"
                  }
                  onClick={() => this.setState({ isOpen: !this.state.isOpen })}
                />
              ) : null}
              {this.renderLifecycleTag()}

              <IMSInfoDelete
                noDelete={this.props.entityType === "ledger"}
                disabled={this.props.isBusy}
                changed={this.state.changed}
                data={this.props.data}
                onDelete={() => this.props.onDelete()}
              />
            </ControlGroup>
          </div>
          <br />
          <Collapse
            isOpen={this.props.keepCollapsed ? this.state.isOpen : true}
          >
            {this.renderEverything()}
          </Collapse>
        </Card>
      </div>
    );
  }
}

export default inject("authStore")(observer(MasterEntity));
